import React, { useContext } from "react"; // 🚀 Added useContext
import { ContextEngine } from "../../../engine/ContextEngine";
import "./TimeMachine.css"; // Optional: add your toast styles here

const TimeMachine = () => {
  const { context } = useContext(ContextEngine);
  const notices = context.view?.notices || []; 
  const activeToast = context.view?.activeToast;

  return (
    <div className="time-machine-container">
      <h4>🕒 Live Activity</h4>
      <div className="notice-list">
        {notices
          .filter(n => {
            if (!n.isTransient) return true; // Always show Actions/Chat
            // 🚀 Hide Status updates if they are older than 5 minutes
            const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
            return n.id > fiveMinutesAgo;
          })
          .map(n => (
            <div key={n.id} className={`history-item kind-${n.kind.toLowerCase()}`}>
               {/* Style these differently in CSS */}
               <small>{n.time}</small> <strong>{n.sender}</strong> {n.text}
            </div>
          ))}
      </div>

      {/* 🚀 The Temporary Pop-up */}
      {activeToast && (
        <div className="presence-toast">
          🔔 {activeToast.text}
        </div>
      )}
    </div>
  );
};

export default TimeMachine;
